import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { customerIsLogged } from '../../utils/authenticated-user';

const PortalPrivateRoute: React.FC<any> = () => {
  return customerIsLogged() ? <Outlet /> : <Navigate to='/' />;
};

export default PortalPrivateRoute;
